// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-list-item-container {
  margin: 12px;
  margin-right: 25px;
  position: relative;
}
.book-item-list-cover {
  width: 43px;
  /* height: 74px; */
  opacity: 1;
  cursor: pointer;
  /* overflow: hidden; */
  border-radius: 1px;
  display: inline-block;
}

.book-item-list-title {
  display: inline-block;
  width: calc(100% - 80px);
  height: 100%;
  position: absolute;
  top: 0px;
  left: 60px;
  cursor: pointer;
}

.book-item-list-author {
  width: 150px;
  float: right;
}
.book-item-list-percentage {
  width: 50px;
  float: right;
}
.book-item-list-subtitle,
.book-item-list-author,
.book-item-list-percentage {
  height: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 18px;
  font-size: 15px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.book-item-list-subtitle {
  width: calc(100% - 250px);
  float: left;
}
.book-item-list-subtitle-text {
  float: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.book-item-list-config {
  cursor: pointer;
}
.list-icon {
  margin: 15px 10px;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/bookListItem/bookListItem.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".book-list-item-container {\n  margin: 12px;\n  margin-right: 25px;\n  position: relative;\n}\n.book-item-list-cover {\n  width: 43px;\n  /* height: 74px; */\n  opacity: 1;\n  cursor: pointer;\n  /* overflow: hidden; */\n  border-radius: 1px;\n  display: inline-block;\n}\n\n.book-item-list-title {\n  display: inline-block;\n  width: calc(100% - 80px);\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 60px;\n  cursor: pointer;\n}\n\n.book-item-list-author {\n  width: 150px;\n  float: right;\n}\n.book-item-list-percentage {\n  width: 50px;\n  float: right;\n}\n.book-item-list-subtitle,\n.book-item-list-author,\n.book-item-list-percentage {\n  height: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-height: 18px;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n}\n.book-item-list-subtitle {\n  width: calc(100% - 250px);\n  float: left;\n}\n.book-item-list-subtitle-text {\n  float: left;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.book-item-list-config {\n  cursor: pointer;\n}\n.list-icon {\n  margin: 15px 10px;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
